/*
  Collections, "By style" view (17 Oct, Martyn): a card stands for a whole style in every colour, so its title drops
  the colour ("Mayfair Subtle Black Watch Strap" reads "Mayfair Subtle Watch Strap"). "Every colour" shows the full title.
  The card's own title and colour come from blocks/wss-card-foot.liquid (data-wss-ctitle, data-wss-colour; grouped straps
  only, so TAG Heuer and single-colour straps keep their titles). After a colour dot swap the card's title follows that colour,
  and switching to "Every colour" puts swapped cards back on their own colour.
  The view toggle lives in sections/wss-collection-head.liquid and sets data-wss-view on the grid.
*/
(function () {
  'use strict';
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function shorten(title, colour) {
    if (!title || !colour) return title;
    var s = title.replace(new RegExp('(^|\\s)' + esc(colour.trim()) + '(?=\\s|$)', 'i'), '$1');
    return s.replace(/\s{2,}/g, ' ').trim() || title;
  }
  function textNodes(li, wanted) {
    var out = [], w = document.createTreeWalker(li, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var p = n.parentNode;
      if (p.closest && p.closest('.wss-dots, .wss-cardfoot, .wss-cardinfo, .wss-cardbadge')) continue;
      if (wanted.indexOf(n.nodeValue.trim()) > -1) out.push(n);
    }
    return out;
  }
  function card(li, mode) {
    var foot = li.querySelector('.wss-cardfoot[data-wss-colour]');
    if (!foot) return;
    if (!li.hasAttribute('data-wss-full')) {
      li.setAttribute('data-wss-full', foot.getAttribute('data-wss-ctitle') || '');
      li.setAttribute('data-wss-colour', foot.getAttribute('data-wss-colour') || '');
    }
    var full = li.getAttribute('data-wss-full'), shown = li.getAttribute('data-wss-shown') || full;
    var want = mode === 'style' ? shorten(full, li.getAttribute('data-wss-colour')) : full;
    if (want === shown && li.hasAttribute('data-wss-shown')) return;
    textNodes(li, [shown, full]).forEach(function (n) { n.nodeValue = n.nodeValue.replace(n.nodeValue.trim(), want); });
    li.setAttribute('data-wss-shown', want);
  }
  function apply() {
    var grid = document.querySelector('ul.product-grid[data-wss-view]');
    if (!grid) return;
    var mode = grid.getAttribute('data-wss-view');
    grid.querySelectorAll(':scope > .product-grid__item').forEach(function (li) { card(li, mode); });
  }
  document.addEventListener('wss:view', function () { setTimeout(apply, 0); });
  // A colour dot swap (By style) changes which strap the card shows: follow its title and colour.
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.wss-dots a[data-wss-swap]');
    if (!dot) return;
    var li = dot.closest('.product-grid__item');
    if (!li || !li.hasAttribute('data-wss-full')) return;
    setTimeout(function () {
      if (dot.getAttribute('aria-current') !== 'true') return;
      var shown = li.getAttribute('data-wss-shown');
      // Put the old text back first so the swap below starts from what's on screen.
      li.setAttribute('data-wss-full', dot.getAttribute('data-title') || li.getAttribute('data-wss-full'));
      li.setAttribute('data-wss-colour', dot.getAttribute('title') || '');
      li.setAttribute('data-wss-shown', shown);
      var grid = li.closest('ul.product-grid');
      var mode = grid ? grid.getAttribute('data-wss-view') : 'style';
      var want = mode === 'style' ? shorten(li.getAttribute('data-wss-full'), li.getAttribute('data-wss-colour')) : li.getAttribute('data-wss-full');
      textNodes(li, [shown]).forEach(function (n) { n.nodeValue = n.nodeValue.replace(n.nodeValue.trim(), want); });
      li.setAttribute('data-wss-shown', want);
    }, 0);
  });
  // Switching to "Every colour" puts any card swapped in By style back on its own colour, so no strap shows twice.
  // On a card's first swap its own dot, photo and price are noted; on the switch, its own dot is clicked while the
  // grid is still in By style (capture phase, before the toggle's own handler), then the photo and price go back.
  var restoring = false;
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.wss-dots a[data-wss-swap]');
    if (dot) {
      if (restoring) return;
      var li = dot.closest('.product-grid__item'), grid = li && li.closest('ul.product-grid');
      if (!li || li.__wssO || !grid || grid.getAttribute('data-wss-view') !== 'style' || dot.getAttribute('aria-current') === 'true') return;
      var img = li.querySelector('img'), price = li.querySelector('.wss-cardfoot__price');
      li.__wssO = {
        dot: li.querySelector('.wss-dots a[aria-current=true]'),
        src: img && img.getAttribute('src'), srcset: img && img.getAttribute('srcset'),
        alt: img && img.getAttribute('alt'), price: price && price.innerHTML
      };
      return;
    }
    var b = e.target.closest && e.target.closest('.wss-view button[value=all]');
    if (!b) return;
    document.querySelectorAll('ul.product-grid > .product-grid__item').forEach(function (li) {
      var o = li.__wssO;
      if (!o) return;
      li.__wssO = null;
      restoring = true;
      try { if (o.dot && o.dot.isConnected) o.dot.click(); } finally { restoring = false; }
      var img = li.querySelector('img'), price = li.querySelector('.wss-cardfoot__price');
      if (img) {
        if (o.src) img.setAttribute('src', o.src);
        if (o.srcset) img.setAttribute('srcset', o.srcset); else img.removeAttribute('srcset');
        if (o.alt != null) img.setAttribute('alt', o.alt);
      }
      if (price && o.price != null) price.innerHTML = o.price;
      li.classList.remove('wss-swapped');
    });
  }, true);
  // The results bar (count, By style / Every colour, Sort; on phones Filter and the toggle) sticks under the header
  // when scrolling (17 Oct, Martyn). A small info button beside the toggle opens a panel saying what each view does
  // (hover or click on desktop, tap on phones), so the bar stays one tidy row.
  var INFO = '<b>By style</b><span>Each strap is shown once, with all its colours on the dots underneath.</span>' +
    '<b>Every colour</b><span>Each strap is split out into its colours.</span>';
  var CSS = '' +
'.facets-controls-wrapper:has(.wss-view),.facets-toggle:has(.wss-view--mobile){position:sticky;top:0;z-index:30;background:var(--color-background,#fff);transition:top .25s ease}' +
'body:has(header-component[data-sticky-state=active]) :is(.facets-controls-wrapper:has(.wss-view),.facets-toggle:has(.wss-view--mobile)){top:var(--header-height,72px)}' +
    /* Even space above and below the bar (17 Oct, Martyn): the section's top padding moves into the bar */
    'results-list:has(.wss-view){padding-block-start:0!important}' +
    '.facets-controls-wrapper:has(.wss-view){padding-block:16px!important}' +
    '.facets-toggle:has(.wss-view--mobile){height:auto!important;min-height:0!important;padding-block:14px!important;margin-block-end:0!important}' +
    /* Full-width background on a layer behind the bar (clipped there, so the Sort menu isn't), with a line once stuck */
    '.facets-controls-wrapper:has(.wss-view)::after,.facets-toggle:has(.wss-view--mobile)::after{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;background:var(--color-background,#fff);box-shadow:0 0 0 100vmax var(--color-background,#fff);clip-path:inset(0 -100vmax)}' +
    '.wss-bar-stuck.facets-controls-wrapper::after,.wss-bar-stuck.facets-toggle::after{box-shadow:0 0 0 100vmax var(--color-background,#fff),0 1px 0 100vmax #e3e8e6;clip-path:inset(0 -100vmax -1px)}' +
    '.wss-view:has(+ .wss-vinfo){margin-inline-end:0!important}' +
    '.facets-controls-wrapper .wss-vinfo{margin-inline-start:-12px}' +
    '.wss-vinfo{position:relative;display:inline-flex;align-items:center;margin-inline-end:14px}' +
    '.facets-toggle:has(.wss-vinfo){justify-content:flex-start!important}' +
    '.facets-toggle .wss-view--mobile{margin-inline-start:auto!important}' +
    '.facets-toggle .wss-vinfo{margin-inline:-6px 0}' +
    '.wss-vinfo__btn{width:30px;height:30px;padding:0;border:0;border-radius:50%;background:none;color:#5e5e5e;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:color .15s,background .15s}' +
    '.wss-vinfo__btn:hover,.wss-vinfo.is-open .wss-vinfo__btn{color:#1a1a1a;background:rgba(0,0,0,.06)}' +
    '.wss-vinfo__btn:focus-visible{outline:2px solid var(--wss-green,#1f5f4a);outline-offset:2px}' +
    '.wss-vinfo__pop{display:none;position:absolute;top:calc(100% + 10px);right:-8px;z-index:5;width:290px;padding:16px 18px;box-sizing:border-box;background:#fff;border:1px solid #e3e8e6;border-radius:8px;box-shadow:0 12px 30px -10px rgba(0,0,0,.25);text-align:left;font-size:14px;line-height:1.45;color:#5e5e5e}' +
    '.wss-vinfo__pop::before{content:"";position:absolute;top:-6px;right:17px;width:10px;height:10px;background:#fff;border-left:1px solid #e3e8e6;border-top:1px solid #e3e8e6;transform:rotate(45deg)}' +
    '.wss-vinfo__pop b{display:block;color:#1a1a1a;font-weight:600}' +
    '.wss-vinfo__pop span{display:block}' +
    '.wss-vinfo__pop span + b{margin-top:10px}' +
    '.wss-vinfo.is-open .wss-vinfo__pop{display:block}' +
    '@media (hover:hover) and (min-width:750px){.wss-vinfo:hover .wss-vinfo__pop{display:block}}' +
    /* Stitching colour filter (17 Oct, Martyn): a disc with a dashed ring in the thread colour, like stitching round
       a leather edge, so it doesn't read as the strap colour. Light threads sit on a dark disc, dark threads on a light one. */
    '.facets .facets__item[data-filter-param-name*=stitching_colour] :is(.checkbox__label,.facets__pill-label)::before{background:var(--wss-stbg,#ecebe7)!important;outline:2.5px dashed var(--wss-st,#1a1a1a);outline-offset:-6px}' +
    '.facets--drawer .facets__item[data-filter-param-name*=stitching_colour] :is(.checkbox__label,.facets__pill-label)::before{outline-offset:-7px}';
  function stitches() {
    document.querySelectorAll('.facets__item[data-filter-param-name*=stitching_colour] :is(.checkbox__label,.facets__pill-label)').forEach(function (l) {
      var name = l.textContent.trim().toLowerCase();
      var hex = getComputedStyle(l).getPropertyValue('--wss-sw').trim(), bg;
      if (name === 'matching') { hex = '#6e4424'; bg = '#a86b3a'; }
      else {
        var m = hex.match(/^#([0-9a-f]{6})$/i);
        var lum = m ? 0.299 * parseInt(m[1].substr(0, 2), 16) + 0.587 * parseInt(m[1].substr(2, 2), 16) + 0.114 * parseInt(m[1].substr(4, 2), 16) : 0;
        bg = lum > 150 ? '#3a3633' : '#ecebe7';
      }
      if (hex && l.style.getPropertyValue('--wss-st') !== hex) l.style.setProperty('--wss-st', hex);
      if (l.style.getPropertyValue('--wss-stbg') !== bg) l.style.setProperty('--wss-stbg', bg);
    });
  }
  function bars() {
    return Array.prototype.slice.call(document.querySelectorAll('.facets-controls-wrapper:has(.wss-view), .facets-toggle:has(.wss-view--mobile)'));
  }
  function hints() {
    if (!document.getElementById('wss-vbar-css')) {
      var st = document.createElement('style'); st.id = 'wss-vbar-css'; st.textContent = CSS; document.head.appendChild(st);
    }
    stitches();
    if (!document.querySelector('.wss-view')) return;
    document.querySelectorAll('.wss-view').forEach(function (v, i) {
      var nx = v.nextElementSibling;
      if (nx && nx.classList.contains('wss-vinfo')) return;
      var box = document.createElement('span');
      box.className = 'wss-vinfo';
      box.innerHTML = '<button type="button" class="wss-vinfo__btn" aria-expanded="false" aria-controls="wss-vinfo-' + i + '" aria-label="What do By style and Every colour mean?">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v5.5" stroke-linecap="round"/><circle cx="12" cy="7.6" r=".6" fill="currentColor"/></svg>' +
        '</button><div class="wss-vinfo__pop" id="wss-vinfo-' + i + '" role="note">' + INFO + '</div>';
      v.insertAdjacentElement('afterend', box);
    });
    stuck();
  }
  function closeInfo(except) {
    document.querySelectorAll('.wss-vinfo.is-open').forEach(function (b) {
      if (b === except) return;
      b.classList.remove('is-open');
      var btn = b.querySelector('.wss-vinfo__btn'); if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wss-vinfo__btn');
    if (btn) {
      var box = btn.parentNode, open = !box.classList.contains('is-open');
      closeInfo(box);
      box.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!(e.target.closest && e.target.closest('.wss-vinfo__pop'))) closeInfo();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeInfo(); });
  var raf = 0;
  function stuck() {
    raf = 0;
    bars().forEach(function (bar) {
      var top = parseFloat(getComputedStyle(bar).top) || 0;
      bar.classList.toggle('wss-bar-stuck', bar.getBoundingClientRect().top <= top + 1 && (window.scrollY > 0 || (document.querySelector('.page-wrapper') || {}).scrollTop > 0));
    });
  }
  document.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(stuck); }, { capture: true, passive: true });
  function start() {
    apply();
    hints();
    var root = document.querySelector('collection-component') || document.body, t;
    if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { apply(); hints(); }, 60); }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
